import { getUtmFromRecord } from "../../utils/utm";

const UTM_HEADERS = ["utm_source", "utm_medium", "utm_campaign", "utm_term"];

function utmRow(i) {
  const u = getUtmFromRecord(i);
  return [u.utm_source, u.utm_medium, u.utm_campaign, u.utm_term];
}

export function exportInscriptosCsv(inscriptos, { eventLabel = "inscriptos", eventType = "ranger" } = {}) {
  if (!inscriptos.length) return;

  const isMetegol = eventType === "metegol";

  const headers = isMetegol
    ? [
        "fecha_inscripcion",
        "nombre",
        "apellido",
        "dni",
        "phone",
        "marca",
        "horario",
        "sede",
        "estadio",
        "tipo",
        ...UTM_HEADERS,
      ]
    : [
        "fecha_inscripcion",
        "nombre",
        "apellido",
        "email",
        "dni",
        "phone",
        "fecha_test_drive",
        "horario",
        "sucursal",
        "direccion",
        "marca",
        "tipo",
        ...UTM_HEADERS,
      ];

  const rows = inscriptos.map((i) =>
    isMetegol
      ? [
          i.fecha || "",
          i.nombre || "",
          i.apellido || "",
          i.dni || "",
          i.phone || "",
          i.marcaSeleccionada || "",
          i.horarioPreferencia || "",
          i.sede || "",
          i.estadioPreferencia || "",
          i.tipoFormulario || "",
          ...utmRow(i),
        ]
      : [
          i.fecha || "",
          i.nombre || "",
          i.apellido || "",
          i.email || "",
          i.dni || "",
          i.phone || "",
          i.fechaTestDrive || "",
          i.horarioPreferencia || "",
          i.sede || "",
          i.ubicacionTestDrive || "",
          i.marcaSeleccionada || "",
          i.tipoFormulario || "",
          ...utmRow(i),
        ]
  );

  const escape = (val) => `"${String(val).replace(/"/g, '""')}"`;
  const csv = [headers.join(","), ...rows.map((r) => r.map(escape).join(","))].join("\n");
  const slug = eventLabel.toLowerCase().replace(/\s+/g, "-");

  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${slug}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
